import axios from 'axios'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import { App } from './src/App'
import styled from '@emotion/styled'
import CircularProgress from '@mui/material/CircularProgress/CircularProgress'

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403) {
      const message =
        error.response.data?.error || error.response.data || 'Access denied'
      document.body.innerHTML = `<div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;padding:2rem;text-align:center"><p style="font-size:1.2rem;color:#333">${message}</p></div>`
      return new Promise(() => {}) // never resolves, halts further app logic
    }
    if (error?.response?.status === 401) {
      const currentPath = window.location.pathname + window.location.search
      window.location.href = `/api/login?current=${encodeURIComponent(
        currentPath,
      )}`
    }
    return Promise.reject(error)
  },
)

axios.interceptors.request.use(
  (config) => {
    const body = document.querySelector('body')
    const version = body?.dataset.version
    if (version && config.headers) {
      config.headers['X-App-Version'] = version
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
`

ReactDOM.render(
  <RecoilRoot>
    <Router>
      <React.StrictMode>
        <React.Suspense
          fallback={
            <LoaderWrapper>
              <CircularProgress size={60} aria-label="Loading" />
            </LoaderWrapper>
          }
        >
          <App />
        </React.Suspense>
      </React.StrictMode>
    </Router>
  </RecoilRoot>,

  document.getElementById('root'),
)
